"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var core_1 = require("@emotion/core");
var core_2 = require("@emotion/core");
var theme_ui_1 = require("theme-ui");
var baseStyles_1 = require("./components/styles/BaseStyles/baseStyles");
var Fonts_1 = require("./components/styles/Fonts/Fonts");
var theme_1 = require("./theme");
var themeGlobalStyles = core_2.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n"])), baseStyles_1.baseStyles, Fonts_1.Fonts);
var ThemeProvider = function (_a) {
    var children = _a.children;
    return (theme_ui_1.jsx(theme_ui_1.ThemeProvider, { theme: theme_1.theme },
        theme_ui_1.jsx(core_1.Global, { styles: themeGlobalStyles }),
        children));
};
exports.ThemeProvider = ThemeProvider;
var templateObject_1;
